import { facilita } from '@/global'
import { panel } from '@/plugins/axios'
import Rest from '../rest'

/**
 * @type {Auth}
 */
export default class Auth extends Rest {

    constructor (options = {}) {
        super(options)
        this.httpPanel = panel
    }

    login(data) {
        return this.http.post(
            '/authenticate',
            data
        )
    }

    loginV2(data) {
        return this.http2.post(
            '/authenticate',
            data
        )
    }

    /**
     * Recebe um token expirado e realiza o refresh deste
     * 
     * @param {Object} data 
     * @returns 
     */
    refreshTokenV2() {
        return this.http2.get('/refreshToken').then(response => {
            if (response?.data && response?.data?.status === 'error') return Promise.reject(response)

            return response
        })
    }

    loginOk(data) {
        return this.httpPanel.post(
            '/ajaxloginok',
            data
        )
    }

    logout(token) {
        return this.httpPanel.get(
            '/ajaxsair',
            {
                params: {
                    vue_panel: true
                },
                headers: {
                    'goscore-token': facilita.gstoken,
                    'goscore-token-user': token
                }
            }
        )
    }

    /**
     * Recebe um token expirado e realiza o refresh deste enviando o refresh_token
     * no Header
     * 
     * @param {Object} data 
     * @returns 
     */
    refreshToken(config) {
        return this.http.get('/refreshToken', config).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }
}